import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@virtual-care/shadcn';
import { useAction } from '@virtual-care/ui';

interface ReactivationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  vendorId: string;
  vendorName: string;
}

export function ReactivationDialog({
  open,
  onOpenChange,
  vendorId,
  vendorName,
}: ReactivationDialogProps) {
  const reactivateMutation = useAction('POST /homecare/{id}/unsuspend', {
    invalidate: ['GET /homecare'],
    onSuccess: () => {
      onOpenChange(false);
    },
  });

  const handleConfirm = () => {
    reactivateMutation.mutate({ id: vendorId });
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="rtl:text-right">
            Reactivate Vendor
          </AlertDialogTitle>
          <AlertDialogDescription className="rtl:text-right">
            Are you sure you want to reactivate <strong>{vendorName}</strong>?
            This will allow them to receive new bookings and appear in patient
            searches.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={reactivateMutation.isPending}
            className="bg-primary hover:bg-primary/90 text-white"
          >
            {reactivateMutation.isPending ? 'Reactivating...' : 'Reactivate'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
